module.exports = __webpack_public_path__ + "static/global-pathfinder-038b417c2c7d19492ecc67fe8318817e.jpg";